import { InformationCircleIcon } from '@hugeicons/core-free-icons';
import { Popover as PopoverPrimitive } from '@base-ui/react/popover';
import { type ReactNode, useState } from 'react';
import { HugeIcon } from './HugeIcon';

export function InfoDisclosure({ children, label }: { children: ReactNode; label: string }) {
  const [open, setOpen] = useState(false);

  return (
    <PopoverPrimitive.Root onOpenChange={setOpen} open={open}>
      <PopoverPrimitive.Trigger aria-label={label} className="flex size-5 items-center justify-center rounded-full text-muted-foreground outline-none hover:bg-card hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring/40" onClick={() => setOpen(true)}>
        <HugeIcon icon={InformationCircleIcon} size={16} strokeWidth={2} />
      </PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Positioner align="center" className="isolate z-50" side="bottom" sideOffset={8}>
          <PopoverPrimitive.Popup className="w-64 rounded-xl border bg-popover p-3 text-xs font-normal leading-5 text-popover-foreground shadow-lg outline-none data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95">
            {children}
          </PopoverPrimitive.Popup>
        </PopoverPrimitive.Positioner>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
}
